import type { Task } from "#/base/task/task.type";

export const createTask = (options: Task): Task => {
  return options;
};